import { z } from "zod";

export const citySchema = z.object({
	type: z.string(),
	features: z.array(
		z.object({
			type: z.string(),
			geometry: z.object({
				type: z.string(),
				coordinates: z.array(z.coerce.string()),
			}),
			properties: z.object({
				label: z.string(),
				name_en: z.string(),
				name_ar: z.string(),
				id: z.coerce.string(),
				Priority: z.number().optional(),
			}),
		}),
	),
});

export type CityType = z.infer<typeof citySchema>;
export type CityFeature = CityType["features"][number];
